import type Stripe from "stripe";
import { CurrencyType } from "../../../../types";
import { Price } from "../Price";
import { PaymentForm } from "./PaymentForm";

export const PaymentStep = (props: {
  clientSecret: string;
  subtotal: number;
  total: number;
  tax: number;
  taxBreakdown: Stripe.Tax.Calculation.TaxBreakdown[];
  currency: CurrencyType;
  onSubmit: () => void;
}) => {
  return props.clientSecret ? (
    <div className="p-3">
      <div>
        <table className="text-right m-auto mr-0">
          <tbody>
            <tr>
              <td> Subtotal: </td>
              <td>
                <Price
                  item={{ price: props.subtotal, currency: props.currency }}
                />
              </td>
            </tr>
            <tr>
              <td>
                Tax (
                {props.taxBreakdown.map((t) => (
                  <span key={t.tax_rate_details.state}>
                    {t.tax_rate_details.state} {t.tax_rate_details.percentage_decimal}%
                  </span>
                ))}
                ):{" "}
              </td>
              <td>
                <Price
                  item={{ price: props.tax, currency: props.currency }}
                  allowZero
                />
              </td>
            </tr>
            <tr>
              <td>Total Cost: </td>
              <td>
                <Price
                  item={{ price: props.total, currency: props.currency }}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>
        <PaymentForm onSubmit={props.onSubmit} />
      </div>
    </div>
  ) : null;
};
